import clsx from "clsx";

export interface ITabItem {
    key: string;
    label: string;
    /** Class icon Font Awesome — vd "fas fa-list". */
    icon: string;
    /** Số badge tròn góc trên (vd số lớp đã đăng ký). Ẩn khi 0/undefined. */
    badge?: number;
}

interface IBottomTabBarProps {
    tabs: ITabItem[];
    activeKey: string;
    onChange: (key: string) => void;
}

/**
 * Thanh tab cố định đáy màn hình cho mobile. Primer không có component tab-bar →
 * primitive tái sử dụng. Mỗi tab cao ≥ 44px (touch-friendly).
 */
const BottomTabBar = ({ tabs, activeKey, onChange }: IBottomTabBarProps) => (
    <nav className="m-tabbar">
        {tabs.map(tab => (
            <button
                key={tab.key}
                type="button"
                className={clsx("m-tab", tab.key === activeKey && "m-tab-active")}
                onClick={() => onChange(tab.key)}
                aria-current={tab.key === activeKey}
            >
                {/* m-tab-ic = viên pill active; m-tab-glyph = mốc định vị badge theo icon */}
                <span className="m-tab-ic">
                    <span className="m-tab-glyph">
                        <i className={tab.icon} />
                        {tab.badge != null && tab.badge > 0 && (
                            <span className="m-tab-badge">{tab.badge > 99 ? "99+" : tab.badge}</span>
                        )}
                    </span>
                </span>
                <span>{tab.label}</span>
            </button>
        ))}
    </nav>
);

export default BottomTabBar;
